/*
** vue router: Auth
*/
import type { RouteRecordRaw } from 'vue-router';

const vrtAuth: RouteRecordRaw = {
  path: '/auth',
  name: 'vrtAuth',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'local/login',
      name: 'vrtAuthLocalLogin',
      component: () => import('./vpgAuthLocalLogin.vue'),
    },
    {
      path: 'refresh/error',
      name: 'vrtAuthRefreshError',
      component: () => import('./vpgAuthRefreshError.vue'),
    },
    {
      path: 'logout',
      name: 'vrtAuthLogout',
      component: () => import('./vpgAuthLogout.vue'),
    },
  ],
};

export default vrtAuth;
